<template>
  <div class="page">
    <h1 class="d-flex align-items-center mt-0 mb-3">
      Маркетинговый блок (ImShop)
      <el-button v-if="!marketingBlock" class="ml-auto" type="primary" size="medium" icon="el-icon-plus" @click="showCreateDialog=true"
                 :disabled="fetchError" :loading="fetchProgress">
        Добавить блок
      </el-button>
    </h1>
    <div v-if="showCreateDialog || marketingBlock"  class="bg-white p-3">
      <MarketingBlockEdit />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import MarketingBlockEdit from '@/components/marketing/MarketingBlockEdit';

export default {
  components: {
    MarketingBlockEdit,
  },

  data() {
    return {
      showCreateDialog: false,
    };
  },

  computed: {
    ...mapGetters({
      fetchProgress: 'marketingBlocks/fetchProgress',
      fetchError: 'marketingBlocks/fetchError',
      marketingBlock: 'marketingBlocks/item',
    }),
  },

  methods: {
    ...mapActions({
      fetchMarketingBlocks: 'marketingBlocks/fetchItems',
    }),
  },

  created() {
    this.fetchMarketingBlocks();
  },

};
</script>
